import * as React from "react";

export function NewPaneIcon() {
  return (
    <svg width={16} height={16} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 7v5a2 2 0 002 2h10a2 2 0 002-2V4a2 2 0 00-2-2H7v1h6a1 1 0 011 1v8a1 1 0 01-1 1H3a1 1 0 01-1-1V7H1z"
        fill="currentColor"
      />
      <path d="M2.5 1v5M0 3.5h5M14 5.5H7" stroke="currentColor" />
    </svg>
  );
}

export function PointerIcon() {
  return (
    <svg width={16} height={16} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.5 1.5l5 12 2-5 5-2-12-5zM8.5 8.5l4 4"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function CursorIcon({
  className,
  style,
}: {
  className: string;
  style: React.CSSProperties;
}) {
  return (
    <svg
      width={18}
      height={18}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        d="M7.5 17.5L0.5 0.5L17.5 7.5L10.5 10.5L7.5 17.5Z"
        fill="currentColor"
        stroke="white"
        strokeOpacity="0.9"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function PanHandIcon() {
  return (
    <svg width={16} height={16} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.5 11V3.5a1 1 0 011-1v0a1 1 0 011 1V9M6.5 11.5L4.182 9.955a1 1 0 00-1.262.125L2 11M2 11l3.621 3.621a3 3 0 002.122.879H10"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.151 10l.849.566V10h1v2.434l-.777-.518L5 11.101V10h.151z"
        fill="currentColor"
      />
      <path
        d="M8.5 9V1.5a1 1 0 011-1v0a1 1 0 011 1V9M10.5 9V2.5a1 1 0 011-1v0a1 1 0 011 1V9"
        stroke="currentColor"
      />
      <path
        d="M12.5 8V5.5a1 1 0 011-1v0a1 1 0 011 1v7a3 3 0 01-3 3H7.726"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.293 10l-.647.646-.353.354.353.354L3 12.707v-1.414L2.707 11 3 10.707V10h-.707z"
        fill="currentColor"
      />
    </svg>
  );
}

export function PinIcon() {
  return (
    <svg
      width={12}
      height={12}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 22L7 17"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 12L12 22L14 14L20 8L22 10L14 2L16 4L10 10L2 12Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
